import { render, staticRenderFns } from "./ChangeTimeDurationDropdown.vue?vue&type=template&id=5350ab7a&functional=true"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports